import React from 'react';
import PropTypes from 'prop-types';

const propTypes = {
	src: PropTypes.string.isRequired,
	className: PropTypes.string
};

const Avatar = ({ src, className }) => (
	<div className={className} style={{background: `url('${src}') #fff 70% 70% / cover no-repeat`}}></div>
);

Avatar.propTypes = propTypes;
export default Avatar;


// WEBPACK FOOTER //
// ./frontend/cabinets/modules/shared/avatar.js